import { sendSignInLinkToEmail, type Auth } from 'firebase/auth'

/** Where we remember the address a sign-in link was sent to (as in Firebase's docs). */
const EMAIL_FOR_SIGN_IN_KEY = 'emailForSignIn'
const EMAIL_LINK_PARAMS = ['apiKey', 'oobCode', 'mode', 'continueUrl', 'lang', 'tenantId']

/** Emails a passwordless sign-in link that returns to the current page. */
export async function sendEmailLink(auth: Auth, email: string) {
  const address = email.trim()
  await sendSignInLinkToEmail(auth, address, {
    url: window.location.origin + window.location.pathname,
    handleCodeInApp: true,
  })
  try {
    localStorage.setItem(EMAIL_FOR_SIGN_IN_KEY, address)
  } catch {
    // Without storage the link still works; we'll just ask for the email again.
  }
}

/** The address a link was sent to from this browser, if it remembers one. */
export function rememberedLinkEmail(): string | null {
  try {
    return localStorage.getItem(EMAIL_FOR_SIGN_IN_KEY)
  } catch {
    return null
  }
}

/**
 * Drops the one-time link parameters from the URL so a reload doesn't try to
 * redeem the code again, and forgets the address unless `keepEmail`.
 */
export function clearEmailLink({ keepEmail = false } = {}) {
  const url = new URL(window.location.href)
  for (const param of EMAIL_LINK_PARAMS) url.searchParams.delete(param)
  window.history.replaceState(window.history.state, '', url)
  if (keepEmail) return
  try {
    localStorage.removeItem(EMAIL_FOR_SIGN_IN_KEY)
  } catch {
    // Ignore — see sendEmailLink.
  }
}
